<template>
  <div>
     <vue-header/>
            <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
     <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <div class="card" style="margin-bottom: 0px;">
          <div class="card-header">
            Foreman Dashboard
          </div>
        </div>
        <div class="card-body" style="background-color:white; margin-bottom:20px;padding: 25px;">
          <div class="row">
            <multiselect  @select="selectOption" @remove="deselectOption" @input="updateUser" select-label="Click to select" deselect-label="Click to remove" v-model="selectedUser" :limit="3" :options="users" :multiple="true" :close-on-select="false"
                   :clear-on-select="false" placeholder="Select User" label="value" track-by="value">
                  </multiselect >
          </div>
        </div>

        <b-card  :header="'Job to Complete ('+jobListCount+')'">
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Filter by</span>
          </div>
          <div class="form-group" v-for="(input,k) in inputs" :id="k" :key="k">

            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options" @change="changeDrop(input)" type="text" style="font-size: 11px;"  class="form-control" v-model="input.name"></b-form-select>

                </div>
              <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 0"><input type="text"  class="form-control" v-model="input.value"></div>
               <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 1"><datetime placeholder = "From Date"  auto v-model="input.from" format="MM/dd/yyyy"></datetime><datetime  placeholder = "To Date"  v-model="input.to" format="MM/dd/yyyy" auto></datetime></div>
              <div class="col-1 " style="padding-right: 5px;padding-left: 5px;"> <span>
                  <i class="fas fa-minus-circle" style="color:red;" @click="remove(k)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-minus-circle" style="color:red;margin-top: 12px;" @click="remove(k)" v-show="k != inputs.length-1"></i>
                  <i class="fas fa-plus-circle" style="color:#6495ed;" @click="add(input.id)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-plus-circle" style="    margin-top: 12px;color:#6495ed;" @click="add(input.id)" v-show="inputs.length == 1"></i>
              </span>
              </div>
            </div>
          </div>
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Sort by</span>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.name"></b-form-select>
              </div>
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="sort_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.order"></b-form-select>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-2"></div>
            <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" @click="applyFilter"> Apply  </button>
              </div>
              <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" style="background-color: white;
color: black;" @click="resetFilter"> Reset  </button>
              </div>
              <div class="col-2"></div>
            </div>
          <!-- </b-collapse> -->
        </b-card>
          <b-card >
          <b-card-text>


              <table id="job_table" class="display" style="width:100%">
                <thead>
                    <tr>
                        <th class="all">Status</th>
                        <th class="all">Job</th>
                        <th class="none">Account Name</th>
                        <th class="none">Last Update</th>
                        <th></th>
                    </tr>
                </thead>
            </table>
          </b-card-text>
        </b-card>
      </div>
     </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Multiselect from 'vue-multiselect'
let user = JSON.parse(localStorage.getItem('userData'))
let foreman_flag = false;
export default {
  name: 'JobListing',
  components : {Loading,Datetime, Multiselect },
  data() {
    return {
      constants: CommonConstants,
      isLoading:false,
      jobListCount:'',
      cust_1 : localStorage.getItem('cust1'),
      cust_2 : localStorage.getItem('cust2'),
      cust_3 : localStorage.getItem('cust3'),
      cust_drop1 : localStorage.getItem('cust_drop1'),
      cust_drop2 : localStorage.getItem('cust_drop2'),
      cust_drop3 : localStorage.getItem('cust_drop3'),
      inputs: [{name: '',value:'',id:0,date_flag:0,from:'',to:''}],
      sort : {name : "job_number", order:'Desc'},
      sort_options : ['Desc','Asc'],
      search_options : [{ value: '', text: 'Select Field',disabled: true },{value: 'job_number', text: 'Job Number'},{value: 'name', text: 'Name'},{value: 'account_name', text: 'Account Name'},{value: 'status', text: 'Status'},{value: 'updated_at', text: 'Last Update'}],
      selectedUser: {id: user.id, value: user.first_name + ' ' + user.last_name},
      users: [],
      postSelectedUser : ''

    }
  },
  mounted : function(){
    let self = this;
    self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
    }
    self.getJobHeader();
    self.loadDTJobs();
    self.openWorkOrder();
    if(user.roles && user.roles[0].role_id == 47){
      foreman_flag = true;
    }
    localStorage.setItem('previous_url','foreman');
  },
  methods :{
    selectOption(option , id){
      let self = this
      self.postSelectedUser = 'init';
      if(option.id == 0){
          self.postSelectedUser = 'all';
      }
    },
    deselectOption(option , id){
      let self = this
      self.postSelectedUser = 'init';
      if(option.id == 0){
          self.postSelectedUser = 'remove';
      }
    },
    updateUser(){
      let self  = this;
      console.log(self.selectedUser);
      if(self.postSelectedUser == 'all')
        self.selectedUser = self.users;
      else if(self.postSelectedUser == 'remove')
        self.selectedUser = [];
      self.loadDTJobs();
    },
    changeDrop(val){
      console.log(val);
      let self= this;

        this.inputs.forEach(function(element,key) {
          if(element.id == val.id){
            if(val.name == 'updated_at' || val.name == 'bid_date' || val.name == "completed_date"){
              self.inputs[key].date_flag = 1;
            }else{
              self.inputs[key].date_flag = 0;
            }
          }
        });
        console.log(self.inputs);
    },
    resetFilter(){
      this.inputs = [{name: '',value:'',id:0,date_flag:0,from:'',to:''}];
      this.sort = {name : "job_number", order:'Desc'};
      this.loadDTJobs();
    },
    applyFilter(){
      let option_val = [];
      this.inputs.forEach(element => {
        if(element.name != '')
          option_val.push(element.name)
        if(element.from != '')
          element.from = moment(element.from).format('YYYY-MM-DD');
        if(element.to != '')
          element.to = moment(element.to).format('YYYY-MM-DD');
      });
      if(new Set(option_val).size !== option_val.length){
        Vue.$toast.error('Please remove duplicate field', {
            position: 'top'
            });
      }else{
        this.loadDTJobs();
      }

    },
    add(index) {
      let self = this;
        self.inputs.push({ name: '',value: '',id : index+1, date_flag:0,from:'',to:''});
    },
    remove(index) {
        this.inputs.splice(index, 1);
    },
    loadDTJobs(){
      var self = this;
      self.isLoading = true;
      $("#job_table").DataTable({
        processing: true,
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Name' ){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                collectionLayout: 'fixed two-column',
                text: "<i class='fas fa-cog' ></i>"+"  Show/Hide Columns"
            }
        ],
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        // {
        //     targets: 32,
        //     className: 'noVis'
        // }
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   true,
        "pagingType": "simple_numbers",
        "pageLength": 25,
        destroy: true,
        colReorder: true,
        language: {
          emptyTable: "No record found.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          processing: 'Loading...',
          // oPaginate: {
          //   sNext: '<i class="fas fa-angle-double-right"></i>',
          //   sPrevious: '<i class="fas fa-angle-double-left"></i>'
          // },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + 'dashboard/foreman/jobs_to_complete/search/pwa',
          "data": function ( d ) {
             d.search_value = self.inputs;
             d.sort_value = self.sort;
             d.selected_user = self.selectedUser;
          },
          dataType: "json",
          dataSrc: function (result) {
            console.log(result);
            //self.allTagsModel = result.data.approved_timesheets;
            self.jobListCount = result.recordsTotal;
            self.isLoading = false;
            return result.data;
          }
        },
        columns: [
          {
            render: function(data, type, full, meta) {
              return (
                full.status ? full.status.charAt(0).toUpperCase() + full.status.slice(1) : ''
              );
            }
          },
          { data: "job", width : "50%",
            render: function(data, type, full, meta) {
              return (
                // if(foreman_flag == true)
                //   return '<div class="wd-vertical-align-middle">' + job + '</div>';
                // else
                //   return '<div class="wd-vertical-align-middle"><a href="/job/' + val.job_id + '">' + job + '</a></div>';
                foreman_flag == true ? "<a class='rework_work_order' href='#' id='rework_work_order' data-log-id='"+ full.id +"'>" + full.job_name + "</a>" : "<a href='/job/"+full.id+"'>"+full.job_name+"</a>"
              );
            }
          },
          { data: "account_name" },

          { data: "updated_at" },

          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#job_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    getJobHeader(){
        let self = this
        axios.get(self.constants.api_url + 'dashboard/foreman/' + user.id, {headers : self.header})
          .then(function (response) {
            self.users = response.data.data.foremen_select;
            localStorage.setItem('frmUsers', JSON.stringify(self.users))
          })
      },
    openWorkOrder (){
      let self = this;
      $(document).on("click","#rework_work_order", function (e) {
        let id = $(e.target).data('log-id');
        self.printReworkWorkOrder(id)
      })
    },
    printReworkWorkOrder: function (id) {
        let self = this;
        let url = this.constants.api_url + 'job/rework-order/' + id + '/' + localStorage.getItem('token')
        axios.get(url ,this.request, { headers: this.header }).then(res => {
          var win = window.open()
          if (win) {
            win.document.body.innerHTML = res.data
          } else
            self.$toasted.show('Popup Blocked, allow it to view content in new tab.', self.errorToast)

        }).catch(e =>
          self.$toasted.show(e, self.successToast),
        )
      },
  },
  watch : {
      inputs (val){
        let option_val = [];
        val.forEach(element => {
          if(element.name != '')
            option_val.push(element.name)
        });
      }
  }
}
</script>

<style>
table.dataTable.dtr-column>tbody>tr>td.control:before {
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900; content: "\f13a "!important;
  background-color: white !important;
  color: #6495ED !important;
  box-shadow: none !important;
  border : none !important;
  cursor: pointer;
  line-height: 16px !important;
}
table.dataTable.dtr-column>tbody>tr.parent td.control:before {
    content: '\f139' !important;
    color: #d33333 !important;
    line-height: 16px !important;
}
.multiselect__tag {
      background: #6495ED !important;
}
.multiselect__option--highlight {
      background: #6495ED !important;
}
.multiselect__option--highlight:after {
  background: #6495ED !important;
}
.multiselect__tag-icon:focus,.multiselect__tag-icon:hover {
  background: #6495ED !important;
}
</style>
